jQuery(document).ready(function ($) {
  $(".nav__exit-trigger,.hamburger").click(function () {
    $(".hamburger").toggleClass("hamburger--active");
    $(".nav__list").toggleClass("nav__list--active");
  });

  $(".nav__item--parent").on("click", ">a", function (e) {
    e.preventDefault();
    const parent = $(this).parent(".nav__item--parent");

    if (parent.hasClass("show")) {
      parent.removeClass("show");
      return;
    }

    parent.addClass("show");
  });

  const matchMedia = () => {
    if ($(".intro").length) {

      $(".intro").on("mousemove", function (e) {
        const x = e.clientX,
          y = e.clientY,
          screen = $(window).outerWidth(true),
          screenHeight = $(window).outerHeight();

        if (window.matchMedia("(min-width: 900px)").matches) {
          if (x > screen / 2) {
            $(this).addClass("intro--en").removeClass("intro--pl");
          } else {
            $(this).addClass("intro--pl").removeClass("intro--en");
          }
        }else{
          if($('.intro-backgrounds-mobile__en').position().top < y && $('.intro-backgrounds-mobile__en').position().top + $('.intro-backgrounds-mobile__en').outerHeight(true) > y){
            $(this).addClass("intro--en").removeClass("intro--pl");
          }else if($('.intro-backgrounds-mobile__pl').position().top < y && $('.intro-backgrounds-mobile__pl').position().top + $('.intro-backgrounds-mobile__pl').outerHeight(true) > y){
            $(this).addClass("intro--pl").removeClass("intro--en");
          }
        }
      });
    }

  };

  /* Call the function */
  matchMedia();
  /* Attach the function to the resize event listener */
  window.addEventListener("resize", matchMedia, false);

  if ($(".slider-list").length) {
    $(".slider-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      appendArrows: false,
      draggable: false,
      appendDots: $(".slider-nav"),
    });
  }
});
